var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "secondary-nav" }, [
      _c("div", { staticClass: "font-weight-bold" }, [
        _vm._v(_vm._s(_vm._f("trans")("Prompt Editor"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {},
        [
          _c("router-link", {
            attrs: { to: { name: "JobCanvas", params: { uuid: _vm.id } } },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({
                  href,
                  route,
                  navigate,
                  isActive,
                  isExactActive,
                }) {
                  return [
                    _c(
                      "button",
                      {
                        staticClass: "btn-back btn text-white font-weight-bold",
                        on: { click: navigate },
                      },
                      [
                        _c("i", {
                          staticClass: "fa lh-inherit fa-chevron-left",
                        }),
                        _vm._v(
                          " " + _vm._s(_vm._f("trans")("Back")) + "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "p-20 justify-content-center d-flex" }, [
      _c("div", { staticClass: "content-container" }, [
        _c("div", { staticClass: "d-flex align-items-center" }, [
          _c(
            "svg",
            {
              attrs: {
                width: "21",
                height: "14",
                viewBox: "0 0 12 8",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M1.33325 0.666626L4.66659 3.99996L1.33325 7.33329M6.66659 7.33329H10.6666",
                  stroke: "white",
                  "stroke-width": "1.33333",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c("h1", { staticClass: "text-white ml-1" }, [
            _vm._v(_vm._s(_vm._f("trans")("Prompt Editor"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", [_c("prompt", { attrs: { isRowDynamic: true } })], 1),
        _vm._v(" "),
        _c("div", [
          _c("p", [
            _vm._v(
              "\n          " +
                _vm._s(
                  _vm._f("trans")(
                    "Click on different prompt items to curate a unique and tailored prompt that perfectly aligns with your artistic vision and improves your overall result."
                  )
                ) +
                "\n        "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", [_c("prompt-editor")], 1),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }